module.exports = __webpack_public_path__ + "img/SALT.1798b8ca.svg";